import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/mentors`;

export const mentorsLinks = {
  root: () => base,
  mentorDetails: (id: number) => `${base}/${id}`,
  endMentorship: () => `${base}/endMentorship`,
  search: (term?: string) => ({ pathname: `${base}/search`, state: { term } }),
  recommendedMentors: () => `${base}/recommendedMentors`,
};

export default mentorsLinks;
